import { DriverStatus } from "packages/libs/shared-models/src/Enum/driver-status.enum";
import { RoleEnum } from "packages/libs/shared-models/src/Enum/role.enum";
import { VehicleTypeEnum } from "../vehicles/vehicle.enum";

export class DriverReq {
  id: number;
  name: string;
  lastName: string;
  dateOfBirth: any | undefined;
  profileImage: any;
  profileImagePath: any;
  email: string;
  phoneNumber: string;
  address: Text;
  state: string;
  city: string;
  userType: string;
  licenceNumber: string;
  licenceClass: string;
  licenceState: string;
  userName: string;
  status: RoleEnum;
  driverStatus: DriverStatus;
  createdUser: string;
  updatedUser: string;
  isActive: boolean;
  versionFlag: number;
  vendorId: number;
  driverType: VehicleTypeEnum;
  licenceExpirydate:any

  constructor(
    id: number,
    name: string,
    lastName: string,
    dateOfBirth: any | undefined,
    profileImage: string,
    profileImagePath: string,

    email: string,
    phoneNumber: string,
    address: Text,
    state: string,
    city: string,
    userType: string,
    licenceNumber: string,
    licenceClass: string,
    licenceState: string,
    userName: string,
    status: RoleEnum,
    driverStatus: DriverStatus,
    createdUser: string,
    updatedUser: string,
    isActive: boolean,
    versionFlag: number,
    vendorId: number,
    driverType: VehicleTypeEnum,
    licenceExpirydate?:any

  ) {
    this.id = id;
    this.name = name;
    this.lastName = lastName;
    this.dateOfBirth = dateOfBirth;
    this.profileImage = profileImage;
    this.profileImagePath = profileImagePath;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.address = address;
    this.state = state;
    this.city = city;
    this.userType = userType;
    this.licenceNumber = licenceNumber;
    this.licenceClass = licenceClass;
    this.licenceState = licenceState;
    this.userName = userName;
    this.status = status;
    this.driverStatus = driverStatus;
    this.createdUser = createdUser;
    this.updatedUser = updatedUser;
    this.isActive = isActive;
    this.versionFlag = versionFlag;
    this.vendorId = vendorId;
    this.driverType = driverType;
    this.licenceExpirydate = licenceExpirydate

  }
}
